import Question from './question.entity';

export default class Answer {
  questionId: string;

  value: string;

  constructor(obj: any = {}) {
    this.questionId = obj.questionId || '';
    this.value = obj.value || '';
  }

  public static of(question: Question): Answer {
    const answer = new Answer();
    answer.questionId = question.questionId;
    return answer;
  }
}
